"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PresenterSettings = require("./PresenterSettings");
Object.keys(_PresenterSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PresenterSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PresenterSettings[key];
    }
  });
});